/**
 * @generated SignedSource<<b05d8890029e0b51f823f1b9db64bd8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClientPortalSettings_Query$variables = {};
export type ClientPortalSettings_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly firmPortalSettings: {
      readonly portalSubdomain: string | null;
      readonly portalCustomDomain: string | null;
      readonly portalSenderDomain: string | null;
      readonly portalReplyTo: string | null;
      readonly defaultShowInvoices: boolean | null;
      readonly defaultAllowFileUpload: boolean | null;
      readonly phaseStatusEnabled: boolean | null;
    } | null;
  } | null;
};
export type ClientPortalSettings_Query = {
  variables: ClientPortalSettings_Query$variables;
  response: ClientPortalSettings_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "client_portal_settings"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"client_portal_settings\")"
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "FirmPortalSettings",
  "kind": "LinkedField",
  "name": "firmPortalSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalSubdomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalCustomDomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalSenderDomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalReplyTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultShowInvoices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultAllowFileUpload",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phaseStatusEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientPortalSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClientPortalSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b9f1201c615810ece74beed9f4e87be",
    "id": null,
    "metadata": {},
    "name": "ClientPortalSettings_Query",
    "operationKind": "query",
    "text": "query ClientPortalSettings_Query {\n  viewer {\n    actualPersonId\n    component(name: \"client_portal_settings\")\n    firmPortalSettings {\n      portalSubdomain\n      portalCustomDomain\n      portalSenderDomain\n      portalReplyTo\n      defaultShowInvoices\n      defaultAllowFileUpload\n      phaseStatusEnabled\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "717eb389d9d2a6d246de8ce1e8dd83e2";

export default node;
